import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';

const Wholesale = () => {
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className="bg-white min-h-screen font-sans">
      <section className="bg-sand py-24 border-b border-sand-dark/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-serif text-5xl md:text-6xl text-gray-900 mb-6">Real ube for your menu.</h1>
          <p className="text-gray-700 text-lg md:text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
            <Link to="/wholesale" className="text-ube underline underline-offset-2">
              20 kg (44 lbs) bulk bags of 100% Ube Powder — trade pricing on request
            </Link>. <strong>Available to approved wholesale partners.</strong>
          </p>
          <p className="text-gray-600 mb-12">LA–OC–SD accounts get in-person tastings and menu development help from our team.</p>
          <div className="bg-white rounded-[3rem] p-8 md:p-12 shadow-sm border border-sand max-w-2xl mx-auto text-left">
            {submitted ? (
              <div className="text-center py-12">
                <div className="w-16 h-16 bg-ube text-white rounded-full flex items-center justify-center mx-auto mb-6"><SafeIcon name="CheckCircle" className="w-8 h-8" /></div>
                <h4 className="font-serif text-2xl text-gray-900 mb-4">Salamat!</h4>
                <p className="text-gray-600">We'll review your application and reply within 2 business days.</p>
              </div>
            ) : (
              <form onSubmit={(event) => { event.preventDefault(); setSubmitted(true); }} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div><label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Business Name</label><input required type="text" className="w-full bg-sand-light border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none" /></div>
                  <div><label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Business Type</label><select required className="w-full bg-sand-light border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none appearance-none"><option>Cafe</option><option>Bakery</option><option>Distributor</option><option>Other</option></select></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div><label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">City</label><input required type="text" className="w-full bg-sand-light border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none" /></div>
                  <div><label className="block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-2">Monthly Volume</label><input required type="text" placeholder="e.g. 10 bulk bags" className="w-full bg-sand-light border-transparent rounded-xl px-4 py-3 focus:ring-2 focus:ring-ube outline-none" /></div>
                </div>
                <Button type="submit" className="w-full py-4 text-lg">Apply for Trade Pricing</Button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Wholesale;